import { createTheme, ThemeProvider } from '@mui/material';
import './App.css';
import PageRoutes from './routes/PageRoutes';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// import Apis from './services/Apis';
import { GoogleOAuthProvider } from '@react-oauth/google';

import 'react-toastify/dist/ReactToastify.css';

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#CB4422",
      },
      secondary: {
        main: '#E1AD1A',
        cart: '#FFA200'
      }
    },
    typography: {
      fontFamily: ['Poppins'],
      h1: {
        fontSize: '60px',
        fontWeight: 600,
        color: '#fff',
        fontFamily: "Poppins"
      },
      h2: {
        fontSize: '30px',
        fontWeight: 400,
        fontFamily: 'Poppins'
      },
      h3: {
        fontSize: '20px',
        fontWeight: 400,
        fontFamily: 'Poppins'
      },
      h4: {
        fontSize: '18px',
        fontWeight: 400,
        fontFamily: 'Poppins'
      },
      h5: {
        fontSize: '16px',
        fontWeight: 400,
        fontFamily: 'Poppins'
      },
      h6: {
        fontSize: '14px',
        fontWeight: 400,
        fontFamily: 'Poppins'
      },
      body1: {
        fontSize: '12px',
        fontWeight: 400,
        fontFamily: 'Poppins'
      },
      body2: {
        fontSize: '10px',
        fontWeight: 400,
        fontFamily: 'Poppins'
      }
    }
  })

  const location = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <GoogleOAuthProvider clientId="315818129983-a5vthc8r6vh7ep832felnd0o57noe02g.apps.googleusercontent.com">
    <ThemeProvider theme={theme}>
      <PageRoutes />
      
    </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
